(function () {
'use strict';

angular
    .module('surveyCampaignControllers')
    .directive('campaignPartCard', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            part: '=',
            readOnly: '=',
            layoutRatio: '=?',
            toRemovePart: '&',
            toUpdatePart: '&',
        },
        restrict: 'AE',
        templateUrl: require('./campaignPartCard.tpl.html'),
        controller: ['$scope', function ($scope) {
            $scope.showOrHideActions = function ($event) {
                if ($scope.readOnly) return;
                $scope.displayActions = !$scope.displayActions;
                $scope.stopEditingCard($event);
                $event.stopPropagation();
            };

            $scope.editCard = function (part, $event) {
                if ($scope.readOnly) return;
                $scope.editedPart = _.clone(part);
                $scope.displayActions = false;
                $scope.isEditingCard = true;
                $event.stopPropagation();
            };

            $scope.stopEditingCard = function ($event) {
                $scope.isEditingCard = false;
                $event.stopPropagation();
            };

            $scope.updatePart = function (part, $event) {
                $scope.toUpdatePart()(part)
                    .then(function (updatedPart) {
                        $scope.part = updatedPart;
                        $scope.isEditingCard = false;
                    });
                $event.stopPropagation();
            }

            // Remove backup system owner
            $scope.removePart = function () {
                $scope.toRemovePart().then(function () {
                    $scope.isRemovedPart = true;
                });
            };
        }],
        link: function (scope, element, attrs) {
            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-sm-12'
            };

            // Display or not actions
            scope.displayActions = false;
            scope.isRemovedPart = false;
            scope.isEditingCard = false;
        }
    };
}
})();